export default __webpack_public_path__ + "static/media/logo.37f6e7ba.svg";